import moment from "moment";
import { useTranslation } from "next-i18next";
import { useRouter } from "next/router";
import { useEffect, useState } from "react";

import Carousel from "../../components/Carousel/Carousel";
import * as ArticleController from "../../controllers/article-controller";
import { DATE_FORMAT_UTC, ROUTES } from "../../utils/consts";
import { filterDraftArticles } from "../../utils/filterDraft";
import { RecommendedArticlesSlide } from "./RecommendedArticlesSlide";

interface IProps {
  tagslug?: string;
  excludeId?: number;
}
const LIST_SIZE = 10;

export const RecommendedArticles = ({ tagslug, excludeId }: IProps) => {
  const [recommendedArticles, setRecommendedArticles] =
    useState<Nullable<ArticleResponse[]>>();
  const router = useRouter();
  const { t } = useTranslation();

  useEffect(() => {
    const fetchRecommendedArticles = async () => {
      const response = await ArticleController.getArticlesByFilter({
        filter: {
          tagslug: tagslug,
          is_draft: false,
          end_date: moment(new Date()).format(DATE_FORMAT_UTC),
        },
        start: 0,
        total: LIST_SIZE + 1,
      });

      const items =
        response?.list
          .filter((item) => item.article_id !== excludeId)
          .slice(0, LIST_SIZE) || null;
      setRecommendedArticles(filterDraftArticles(items));
    };

    tagslug && fetchRecommendedArticles();
  }, [excludeId, tagslug]);

  const handleClick = (article_index: string) => {
    router.push(`${ROUTES.ARTICLE.PATH}${article_index}`);
  };

  if (!recommendedArticles) return null;

  return (
    <section className="article-page-recommended">
      <span className="cards-slider-left-orient-title">{t("SeeAlso")}:</span>
      <div className="cards-slider-left-orient">
        <Carousel className="cards-slider-left-orient">
          {recommendedArticles.map((card) => (
            <RecommendedArticlesSlide
              key={card.article_index}
              itemId={card.article_index}
              card={card}
              onClick={() => handleClick(card.article_index)}
            />
          ))}
        </Carousel>
      </div>
    </section>
  );
};
